import { motion } from "framer-motion";
import * as LucideIcons from "lucide-react";

interface Step {
  step: number;
  icon: string;
  title: string;
  description: string;
}

interface VisualStepsProps {
  steps: Step[];
}

export function VisualSteps({ steps }: VisualStepsProps) {
  if (!steps || steps.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      {steps.map((step, index) => {
        // Get icon from Lucide
        const Icon = (LucideIcons as any)[step.icon] || LucideIcons.Circle;

        return (
          <motion.div
            key={step.step || index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-card border border-border rounded-2xl p-4"
          >
            {/* Step Number & Icon */}
            <div className="flex items-center gap-3 mb-3">
              <div className="relative">
                <div className="h-14 w-14 rounded-2xl bg-primary/10 flex items-center justify-center">
                  <Icon className="h-7 w-7 text-primary" />
                </div>
                <div className="absolute -top-1 -left-1 h-6 w-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xs font-bold">
                  {index + 1}
                </div>
              </div>
              <h3 className="font-semibold text-lg flex-1">
                {step.title}
              </h3>
            </div>

            {/* Description */}
            <p className="text-muted-foreground text-sm leading-relaxed pl-1">
              {step.description}
            </p>
          </motion.div>
        );
      })}
    </div>
  );
}
